import { Component, OnInit } from '@angular/core';
import 'jquery';
import { ViewEncapsulation } from '@angular/core';
import { BoService } from '../services/bo.service';
declare var $: any;

@Component({
  selector: 'app-support',
  templateUrl: './support.component.html',
  styleUrls: ['./support.component.css'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class SupportComponent implements OnInit {

  constructor(private boService: BoService) { }

  ngOnInit() {
    let t = this;
    $(document).ready(function(){
      // --- Initialisation globale : --------------------------------------------
      $('.menubo,.headerbo').css({'display':'flex'});
      var wiw=$(window).width();
      var darkMode='off';
      var contrastMode='off';
      if(JSON.parse(localStorage.getItem('infoUser')).darkMode=='on'){darkMode='on'};
      if(JSON.parse(localStorage.getItem('infoUser')).contrastMode=='on'){contrastMode='on'};
      $('#htitsec').html('Assistance');
      $('#htitsec2').html('Support et contacts');
      $('.menubs').attr('id','');$('.menubs-6').attr('id','actif1');
      $('.secmenu2bs').attr('id','');$('.6s2').attr('id','actif2');
      if(wiw>610){
        $('#htitsec,#htitsec2,#fles').css({'display':'inline'});
      }else{
        $('#htitsec2').css({'display':'inline'});
        $('#fles').css({'display':'none'});
      };
      var rootStyles = getComputedStyle(document.documentElement);
      var colorBorderMuted = rootStyles.getPropertyValue('--ui-color-border-muted').trim() || '#e9edf1';
      $('.headerbo').css({'border-color': colorBorderMuted, 'box-shadow':'none'});
      $(window).scroll(function(){
        var sw= $(this).scrollTop();
        if(sw>60){
          $('.headerbo').css({'border-color':'transparent','box-shadow': 'var(--ui-shadow-sm)'});
        }else{
          $('.headerbo').css({'border-color': colorBorderMuted, 'box-shadow':'none'});
        };
      });
      $('body').css({'overflow':'auto'});
      $(window).scrollTop(0);
      //--------------------------------------------------------------------------
      // --- Recuperation et création des data utiles pour jq : ------------------
      var dataHelp;
      var colorDanger = rootStyles.getPropertyValue('--ui-color-danger').trim() || '#970000';
      var colorDangerLight = rootStyles.getPropertyValue('--ui-color-danger-lighter').trim() || '#ffedea';
      var cus=['<span style="color:'+colorDanger+';background-color:'+colorDangerLight+'">','</span>'];
      dataHelp=t.boService.helpBook;
      // ERROR : t.boService.errorLoad();
      loadHelp(dataHelp);
      t.boService.screenMode(darkMode,contrastMode)
      $('.blocLoader').fadeOut(0);
      function loadHelp(x){
        $('.conttopic').html('');
        if(x.length==0){
          $('.conttopic').html('<div class="searchNull"><i class="far fa-info-circle"></i> &nbsp;Auncun contenu ne correspond à votre recherche</div>');
        }else{
          for(var i=0;i<x.length;i++){
            var clastopicp='topic';
            var liname=x[i].name;
            var licontent=x[i].content;
            if(term){
              var lis=liname.split(term);
              if(lis.length>1){
                liname='';for(var d=0;d<lis.length;d++){if(d!=(lis.length)-1){liname+=lis[d]+cus[0]+term+cus[1];}else{liname+=lis[d]};};
              };
              lis=licontent.split(term);
              if(lis.length>1){
                clastopicp='topic topicopen';
                licontent='';for(var d=0;d<lis.length;d++){if(d!=(lis.length)-1){licontent+=lis[d]+cus[0]+term+cus[1];}else{licontent+=lis[d]};};
              };
            };
            licontent=licontent.replace(/\+/g,'<br>');
            $('.conttopic').append('<div class="'+clastopicp+'" id="topic'+i+'"><div class="headtopic">'+liname+'</div><div class="bodytopic">'+licontent+'</div></div>')
          };
        };
      };
      var html='<style>.detconsoIWP{ width: 90%; margin: auto; margin-top: -2px; border-radius: 0px 0px 4px 4px; padding-bottom: 22px; padding-top: 10px; font-size: 17px; line-height: 33px; background-color: var(--ui-color-bg); box-shadow: var(--ui-shadow-sm); border: solid 1px var(--ui-color-border-muted); text-align: center; color: var(--ui-color-text); } .tabconsoIWP{ width: 90%; margin-left: 5%; text-align: left; white-space: nowrap; } .thconsoIWP{ font-size: 13px; height: 50px; color: var(--ui-color-text-muted); } .trconsoIWP{ font-size: 14px; color: var(--ui-color-text); } .ftdcIWP{ padding-left: 20px; } .ltdcIWP{ text-align: right; } table{ line-height: 25px; } .tabtotconsoIWP{ width: 90%; margin-left: 5%; text-align: left; white-space: nowrap; color: var(--ui-color-text-muted); font-size: 13px; } .bcoIWP{ width: 80%; height: 90px; margin: auto; margin-left: 10%; margin-top: 60px; padding-top: 35px; border-radius: 4px; font-size: 17px; background-color: var(--ui-color-bg-muted); border: solid 1px var(--ui-color-border-muted); color: var(--ui-color-text-muted); padding-bottom: 20px; text-align: center; line-height: 33px; } .icoIWP{ width: 100%; margin: auto; margin-top: 55px; font-size: 14px; text-align: center; color: var(--ui-color-text); }</style><body><div class="detconsoIWP"> <table class="tabconsoIWP"> <tr class="thconsoIWP"> <td width="25%"> Quantité </td> <td width="50%"> Produit </td> <td width="30%" class="ltdcIWP"> Montant TTC </td> </tr> <tr class="trconsoIWP"> <td width="25%" class="ftdcIWP"> 1 </td> <td width="45%"> Burger bacon </td> <td width="30%" class="ltdcIWP"> 12,00 € </td> </tr> <tr class="trconsoIWP"> <td width="25%" class="ftdcIWP"> 2 </td> <td width="50%"> Bières Olympus </td> <td width="345%" class="ltdcIWP"> 9,00 € </td> </tr> <tr class="trconsoIWP"> <td width="25%" class="ftdcIWP"> 1 </td> <td width="45%"> Grand soda </td> <td width="30%" class="ltdcIWP"> 5,50 € </td> </tr> </table> <div style="background-color:var(--ui-color-border);width:90%;height:1px;margin-left:5%;margin-top:12px;margin-bottom:15px;"></div> <table class="tabtotconsoIWP"> <tr> <td width="75%"> Total HT </td> <td width="25%" style="color:var(--ui-color-text);font-weight:800;text-align:right"> 22,05 € </td> </tr> <tr> <td width="75%"> TVA </td> <td width="25%" style="color:var(--ui-color-text);font-weight:800;text-align:right"> 1,45 € </td> </tr> <tr> <td width="75%" style="font-weight:800;font-size:14px;"> Total TTC </td> <td width="25%" style="color:var(--ui-color-text);font-weight:800;text-align:right;font-size:16px;"> 23,50 € </td> </tr> </table> </div></body>';
      //--------------------------------------------------------------------------
      $('.closeheadsp').click(function(){
        $('.headersp').css({'opacity':'0.0','height':'0px'});
      });
      $('.conttopic').on('click','.headtopic',function(){
        var tto=$(this).parent();
        if(tto.attr('class')=='topic'){
          $('.topic').removeClass('topicopen');
          tto.addClass('topicopen');
        }else{
          $('.topic').removeClass('topicopen');
        };
      });
      var dataSearch=[];
      var term='';
      function searchHelp(){
        if(term){
          dataSearch=dataHelp.filter(function(e){
            return (e.name.search(term)!=-1)||(e.content.search(term)!=-1);
          });
          loadHelp(dataSearch);
        }else{
          dataSearch=[];
          loadHelp(dataHelp);
        };
      };
      $('.searchhelp').keyup(function(){
        term=$(this).val().toString()||'';
        searchHelp();
      });
      // ---------------------------------------------------------
    });
  }

}
